import React, { useEffect } from "react";
import HeroSection from "./HeroSection";
import PlansSection from "./PlansSection";
import SecuritySection from "./SecuritySection";
import ServersSection from "./ServersSection";
import AppDownloadSection from "./AppDownloadSection";
import Footer from "./Footer";
import api from "../lib/api";

const HomePage = () => {
  useEffect(() => {
    // Test API connection on mount (production check)
    api.get("/")
      .then(res => console.log("Backend connection successful:", res.data))
      .catch(err => console.warn("Backend connection failed or using mocks:", err.message));
  }, []);

  return (
    <div className="min-h-screen bg-black">
      <HeroSection />
      <PlansSection />
      <SecuritySection />
      <ServersSection />
      <AppDownloadSection />
      <Footer />
    </div>
  );
};

export default HomePage;